<template>
  <div class="body-pergunta">
      <b-modal ref="add-nova-pergunta"
      size="md"
      centered
      title="Adicionar itens para o cabeçalho"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      body-class="rounded-bottom-1rem "
      content-class="rounded-1rem"
      @shown="focarDescricao"
      >
      <template #modal-title>
          <div class="header-title">{{edicaoPerguntas === true ? 'Editar item' : metadado === true ? 'Adicionar item anexo' : 'Adicionar item avaliação' }}</div>
      </template>
          <div class="container-add-pergunta">
            <div v-if="EscolherTipoPergunta && file64 === null && galeria === false">

                <label v-if="metadado === true" class="labelsearch margem">Selecione qual será o tipo do item que deseja adicionar</label>
                <select v-model="novoItemTipo" name="statusTipo" class="form-control" id="exampleFormControlSelect2" v-if="metadado === true">
                    <option :value = null disabled>Selecione o Tipo</option>
                    <option v-for="data in tipoCampo" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
                </select>

                <div  style="width: 100%;" >
                  <label class="labelsearch margem mt-2">Insira a descrição do item {{ metadado === true ? 'anexo' : 'avaliação' }}</label>
                  <b-form-textarea ref="descricaoTextarea" class="input-descricao" rows="5" v-model="novoPergunta" :placeholder="metadado === true ? 'Descrição do item anexo' : 'Descrição do item avaliação'"></b-form-textarea>
                </div>

                <b-form-group
                  class="font pivs"
                  style="margin-bottom: 1rem;"
                  id="Input-group-template-pes"
                  label="Nível Prioridade"
                  label-for="input-template-pes"
                >
                  <b-form-input
                    class="input"
                    id="input-new-pes"
                    name="input-new-pes"
                    type="text"
                    v-model="formattedValue"
                    placeholder="Dígite o nível de prioridade"
                  ></b-form-input>
                </b-form-group>

                <div class="switch-container mt-2"  v-if="novoItemTipo !== null && novoItemTipo != 2 && novoItemTipo != 4 && novoItemTipo != 5 && novoItemTipo != 10">
                  <div>Pergunta terá mais de uma resposta?</div>
                  <div class="switchMultiplo mt-2">
                    <label class="switch">
                      <input type="checkbox" v-model="multiplo" @click="multiplo == !multiplo">
                      <span class="slider round"></span>
                    </label>
                    <div>
                      {{ multiplo === false ? 'Não' : 'Sim' }}
                    </div>
                  </div>
                </div>

                <div class="switch-container mt-2">
                  <div>Resposta obrigatória?</div>
                  <div class="switchMultiplo mt-2">
                    <label class="switch">
                      <input type="checkbox" v-model="respostaObrigatoria">
                      <span class="slider round"></span>
                    </label>
                    <div>
                      {{ respostaObrigatoria === false ? 'Não' : 'Sim' }}
                    </div>
                  </div>
                </div>

                <input type="file" id="impor-Img" itemid="impor-Img"  accept="image/png, image/jpeg" v-on:change="GetValueFile">

                <div v-if="novoItemTipo == 4 && galeria === false">
                  <div class="d-flex">
                      <div class="img-cadastradas">Imagens Cadastradas ({{opcaoImagemLocal.length >= 10 ? opcaoImagemLocal.length : '0' + opcaoImagemLocal.length}})</div>
                      <div v-if="opcaoImagemLocal.length > 0" class="img-ver-todas" @click="irParaGaleria">Ver todas</div>

                  </div>
                  <div style="display: flex; align-items: center; gap: 0.5rem">
                    <div class="container-img "  v-for="(arquivo,index) in opcaoImagemLocal.slice(0, 2)" v-bind:key="index">

                      <div v-if="arquivo.file64 === undefined ? arquivo.base64 === '' ? false : true : true" class="card-img-pergunta-pre-viualizacao card-img-pergunta-border card-img-pergunta-pre-visualizacao">
                        <img :src="arquivo.file64 === undefined ? 'data:image/jpeg;base64,' + arquivo.base64 : arquivo.file64" :id="arquivo.arquivoId" @click="modal_preview_imagem(arquivo)" class="img-galeria  altura-img card-img-pergunta-pre-visualizacao"/>
                        <div class="comprovante-footer">{{ arquivo.descricaoPerguntaSelecaoImagem }}</div>
                      </div>

                      <b-skeleton-img v-else animation="wave" class="icone-img"></b-skeleton-img>

                    </div>

                    <div style="display: flex; align-items: center;" class="img-body-uplaod" v-on:click="openFileImg">
                      <div class="img-body-info"  >
                        <i class="fas fa-cloud-upload-alt" style="font-size: 35px"></i>
                        <div  class="mt-3" style="font-size: 14px; text-align: center;" >FAÇA O UPLOAD</div>
                        <div style="font-size: 12px; text-align: center;" >Escolha a imagem</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="novoItemTipo == 5">
                  <div class="d-flex">
                      <div class="img-cadastradas">Perguntas Cadastradas ({{opcaoImagemLocal.length >= 10 ? opcaoImagemLocal.length : '0' + opcaoImagemLocal.length}})</div>
                  </div>
                  <div style="display: flex; align-items: center; gap: 0.5rem">
                    <b-input v-model="perguntaSelecao"  placeholder="Adicione o texto da alternativa" />
                    <div class="icone-button-pergunta-selecao" id="campoAddSelecaoTexto" v-b-tooltip.hover :title="'Adicionar novas opções'" @click="adicionarOpcao(null)">
                      <i class="fas fa-plus"></i>
                    </div>
                  </div>
                  <div class="w-100 mt-2">
                    <div class="container_pergunta_selecao" v-for="(itens,index) in opcaoTextoLocal" v-bind:key="index">
                    <div class="pergunta_selecao" v-if="itens.tag === undefined || itens.tag === false">
                      {{itens.descricaoPerguntaSelecaoImagem}}
                    </div>
                    <div class="pergunta_selecao" style="color: #bb0b0b" v-if="itens.tag === true">
                      {{itens.descricaoPerguntaSelecaoImagem}}
                    </div>
                    <div  v-if="itens.tag === undefined || itens.tag === false" class="delete_pergunta_selecao"  v-b-tooltip.hover :title="'Excluir opção'" @click="removerOpcoesTexto(itens)">
                      <i class="fas fa-trash"></i>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="d-flex container_cancel_save">
                    <div class="cancelar">
                        <button class="button-cancel" @click="fecharPopUptAdd">CANCELAR</button>
                    </div>
                    <div class="criar" v-if="edicaoPerguntas === false">
                        <button class="button-save" @click="adicionarPergunta">ADICIONAR</button>
                    </div>
                    <div class="criar" v-else>
                        <button class="button-save" @click="editarPergunta">EDITAR</button>
                    </div>
                </div>

              </div>

              <div  v-if="galeria === true">
                <div class="container-galeria">
                  <div class="galeria">
                    <div class="container-img-galeria d-flex" v-for="(arquivo, index) in opcaoImagemLocal" v-bind:key="index">
                      <div class="card-img-pergunta-pre-viualizacao card-img-pergunta-galeria">
                        <img v-if="arquivo.exclusao === false" :src="arquivo.file64 === undefined ? 'data:image/jpeg;base64,' + arquivo.base64 : arquivo.file64" class="img-galeria  card-img-pergunta-galeria" :id="arquivo.arquivoId" @click="modal_preview_imagem(arquivo)"  />
                        <div class="comprovante-footer">{{ arquivo.descricaoPerguntaSelecaoImagem }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex container_cancel_save">
                  <div class="cancelar">
                      <button class="button-cancel" @click="voltaParaMenu">VOLTAR</button>
                  </div>
                </div>
              </div>

              <div v-if="file64 != null">
                <div class="d-flex w-100">
                  <label class="labelsearch margem mt-2">Imagem</label>

                  <input type="file" id="impor-Img" itemid="impor-Img"  accept="image/png, image/jpeg" v-on:change="GetValueFile">

                  <div class="container-icone-edicao d-flex">
                    <div class="icone-button" v-b-tooltip.hover :title="'Editar Imagem'" v-on:click="openFileImg">
                      <i class="fas fa-pen"></i>
                    </div>
                    <div class="icone-button" v-b-tooltip.hover :title="'Excluir Imagem'" @click="removerOpcoesImagem">
                      <i class="fas fa-trash"></i>
                    </div>
                  </div>
                </div>

                <div class="comprovante-file">
                  <img :src="file64" class="img-galeria"/>
                  <div class="comprovante-footer">{{ nameFile }} </div>
                </div>

                <div  style="width: 100%;" >
                    <label class="labelsearch margem mt-2">Insira a descrição do campo</label>
                    <b-form-textarea ref="descricaoTextarea"  class="input-descricao" rows="5" v-model="descricaoImagem"  placeholder="Descrição da imagem"></b-form-textarea>
                  </div>

                  <div class="d-flex container_cancel_save">
                    <div class="cancelar">
                        <button class="button-cancel" @click="voltaParaMenu">CANCELAR</button>
                    </div>
                    <div class="criar">
                        <button class="button-save" @click="adicionarOpcaoImagem">ADICIONAR</button>

                    </div>
                  </div>
              </div>

              <div v-if="!EscolherTipoPergunta" class="container_cadastra_pergunta">
                <label class="labelsearch margem">Descrição</label>
                <div  style="width: 100%;">
                  <b-form-textarea  ref="descricaoTextarea"  class="input-descricao" rows="5" v-model="novoPergunta"  placeholder="Descrição da avaliação"></b-form-textarea>
                </div>

                <b-form-group
                  class="font pivs"
                  id="Input-group-template-pes"
                  label="Nível Prioridade"
                  label-for="input-template-pes"
                >
                  <b-form-input
                    class="input"
                    id="input-new-pes"
                    name="input-new-pes"
                    type="text"
                    v-model="formattedValue"
                    placeholder="Dígite o nível de prioridade"
                  ></b-form-input>
                </b-form-group>

                <div class="d-flex container_cancel_save">
                    <div class="cancelar">
                        <button class="button-cancel" @click="fecharPopUptAdd">CANCELAR</button>
                    </div>
                    <div class="criar" v-if="edicaoPerguntas === false">
                        <button class="button-save" @click="adicionarPergunta">ADICIONAR</button>
                    </div>
                    <div class="criar" v-else>
                        <button class="button-save" @click="editarPergunta">EDITAR</button>
                    </div>
                </div>

              </div>

              <div id="preview_imagem" class="modal">
                <div class="d-flex">
                   <span class="editar" v-b-tooltip.hover :title="'Editar Imagem'" @click="habilitar_edicao_imagem()">
                      <div class="icone-button-review">
                        <i class="fas fa-pen"></i>
                      </div>
                    </span>
                    <span class="close" @click="fecha_modal_preview_imagem" v-b-tooltip.hover :title="'Fechar popUp'">
                      <div class="icone-button-review">
                        <i class="fas fa-times"></i>
                      </div>
                    </span>
                </div>
                <img class="modal-content" id="img_modal">
                <div id="caption"></div>
              </div>

          </div>
      </b-modal>
  </div>
</template>

<script>
import addquestion from './addquestion'
export default addquestion
</script>
<style scoped>
.icone-img {
  height: 10rem;
  border-radius: 10px;
  width: 9rem;
  display: flex;
  margin-bottom: 14px;
  justify-content: center;
  align-items: center;
}
.container_pergunta_selecao {
  display: flex;
  padding: 4px;
  width: 100%;
  border-bottom: 1px solid #dddddd;
}
.pergunta_selecao{
  width: 100%;
  font: normal normal 600 14px / 24px Segoe UI;
}
.delete_pergunta_selecao {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 5%;
}
.container-icone-edicao {
  width: 100%;
  gap: 1rem;
  justify-content: end;
}
.icone-button {
  cursor: pointer;
  border: 1px solid #008148;
  color: #008148;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 28px;
  font-size: 11px;
}
.icone-button-pergunta-selecao {
  cursor: pointer;
  border: 1px solid #e4e4e4;
  color: #535353;
  background-color: #e4e4e4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 35px;
  font-size: 11px;
}
.icone-button-pergunta-selecao.clicked {
  border: 1px solid #008144;
  color: white;
  background-color: #008144;
}
.img-galeria {
  object-fit: cover;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
}
.img-pre-visualizacao {
  object-fit: cover;
  border-radius: 8px;
  overflow: hidden;
}
.altura-img {
  width: 10rem;
}
.galeria {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.container-galeria {
  height: 25rem;
  overflow: auto;
  width: 100%;
  border-bottom: 1px solid #D4D4D4;
}

.container-galeria::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}
.container-galeria::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
}
.container-galeria::-webkit-scrollbar-thumb {
    background: #dad7d7;
}

.container-img-galeria {
  flex: 1 1 calc(33.333% - 1rem);
}

.container-img-galeria:nth-child(3n+1) {
  clear: both;
}
.body-pergunta {
  width: 100%;
}
#impor-Img {
  display: none;
}
.labelsearch {
  font: normal normal 600 14px / 24px Segoe UI;
}
.header-title {
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.container_cadastra_pergunta{
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
}
.input-descricao{
    width: 100%;
    margin-top: 0.5rem;
    border: 1px solid rgb(216, 216, 216);
    border-radius: 2px;
    padding-left: 17px;
    margin-bottom: 1rem;
}
.container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 3rem;
  column-gap: 20px;
 }
 .button-cancel{
   background-color: #b60000;
   color: white;
 }
 .button-save{
  background-color: darkgreen;
  color: white;
 }

.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 58px;
  height: 31px;
  margin-bottom: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffcdcd;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: #881616;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
background-color: #CBE9CF;
}

input:checked + .slider:before {
-webkit-transform: translateX(26px);
-ms-transform: translateX(26px);
transform: translateX(26px);
background-color: #1C6228;
}

.slider.round {
border-radius: 34px;
}

.slider.round:before {
border-radius: 50%;
}
.switchMultiplo{
gap: 1rem;
display: flex;
align-items: center;
}

.img-body-info{
width: 100%;
display: flex;
height: 100%;
flex-direction: column;
justify-content: center;
align-items: center;
}

.img-body-uplaod{
width: 100%;
height: 10rem;
font-size: 25px;
color: grey;
border-radius: 10px;
position: relative;
flex-direction: column;
margin-bottom: 15px;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
border: 2px dotted #bebebe;
transition: .5s;
}

.img-body-dawnload {
width: 100%;
height: 10rem;
font-size: 25px;
color: grey;
border-radius: 10px;
position: relative;
flex-direction: column;
margin-bottom: 15px;
display: flex;
justify-content: center;
position: relative;
align-items: center;
cursor: pointer;
transition: .5s;
}

.container-img {
width: fit-content;
display: flex;
gap: 0.5rem;
}
.card-img-pergunta-pre-viualizacao[data-v-4df435f8] {
  height: 10rem;
  font-size: 25px;
  color: grey;
  border-radius: 10px;
  position: relative;
  margin-bottom: 15px;
  display: flex;
  position: relative;
  -ms-flex-align: center;
  cursor: pointer;
  -webkit-transition: .5s;
  transition: .5s;
}
.card-img-pergunta-galeria {
width: 8rem;
}
.card-img-pergunta-pre-visualizacao {
width: 9rem;
}
.card-img-pergunta-border {
border: 2px dotted #bebebe;
}
.comprovante-footer{
  width: 100%;
  font: normal normal 600 11px / 24px Segoe UI;
  white-space: pre-wrap;
  word-break: break-all;
  height: fit-content;
  line-height: 14px;
  padding: 5px;
  position: absolute;
  font-weight: bold;
  background: rgb(173 173 173);
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(255, 255, 255);
  border-radius: 0px 0px 10px 10px;
}
.download-comprovante{
  height: 30px;
  position: absolute;
  top: 0px;
  display: flex;
  font-size: 13px;
  right: 0px;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  width: 40px;
  background: #008144;
  border-radius: 0px 8px 0px 8px;
}
.comprovante-file{
  width: 100%;
  height: 10rem;
  font-size: 25px;
  color: grey;
  border-radius: 10px;
  position: relative;
  flex-direction: column;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  cursor: pointer;
  border: 2px dotted #bebebe;
  transition: .5s;
}
.img-body-dawnload.hover-class{
background-color: #01683a8a;
transition: .5s;
color: white;
}
.img-cadastradas {
width: 100%;
margin: 2rem 0 1rem 0;
font: normal normal 600 14px / 24px Segoe UI;
}
.img-ver-todas {
display: flex;
margin: 2rem 0 1rem 0;
width: 100%;
justify-content: end;
text-decoration: underline;
font: normal normal 600 14px / 24px Segoe UI;
}

/* The Modal (background) */
.modal {
display: none; /* Hidden by default */
position: fixed; /* Stay in place */
z-index: 1; /* Sit on top */
padding-top: 100px; /* Location of the box */
left: 0;
top: 0;
width: 100%; /* Full width */
height: 100%; /* Full height */
overflow: auto; /* Enable scroll if needed */
background-color: rgb(0,0,0); /* Fallback color */
background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
margin: auto;
display: block;
width: 35%;
}

/* Caption of Modal Image */
#caption {
margin: auto;
display: block;
width: 80%;
max-width: 700px;
text-align: center;
color: #ccc;
padding: 10px 0;
height: 150px;
}

/* Add Animation */
.modal-content, #caption {
-webkit-animation-name: zoom;
-webkit-animation-duration: 0.6s;
animation-name: zoom;
animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
from {-webkit-transform:scale(0)}
to {-webkit-transform:scale(1)}
}

@keyframes zoom {
from {transform:scale(0)}
to {transform:scale(1)}
}

/* The Close Button */
.close {
position: absolute;
top: 15px;
right: 35px;
font-size: 30px;
font-weight: bold;
transition: 0.3s;
}

.close:hover,
.close:focus {
color: #68b77f;
text-decoration: none;
cursor: pointer;
}

.editar {
position: absolute;
top: 15px;
right: 110px;
font-size: 20px;
font-weight: bold;
-webkit-transition: 0.3s;
transition: 0.3s;
}

.editar:hover,
.editar:focus {
color: #68b77f;
text-decoration: none;
cursor: pointer;
}
.icone-button-review {
  cursor: pointer;
  border: 2px solid #008148;
  color: #008148;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 48px;
  font-size: 15px;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
.modal-content {
  width: 20%;
}
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/SubGroupDetail/addquestion/addquestion.vue